import { URLS, getUrls } from 'api/config';
import $api from 'api/http';

export default class AuthService {
    static async login(data: { email: string; password: string }) {
        return $api.post(getUrls({ name: URLS.login }), data);
    }
    static async activate(data: { token: string; password: string; firstName: string; lastName: string }) {
        return $api.post(getUrls({ name: URLS.activate }), data);
    }
    static async resetSend(data: { email: string; url: string }) {
        return $api.post(getUrls({ name: URLS.reset_send }), data);
    }
    static async resetChange(data: { token: string; password: string }) {
        return $api.post(getUrls({ name: URLS.reset_change }), data);
    }
}
